<template>
  <div class="wrapper">
    <el-page-header
      :content="title"
      @back="$router.push({ path: '/school-home-page/training-course' })"
    >
    </el-page-header>

    <el-row type="flex" class="row-bg" justify="center" :gutter="20">
      <el-col :span="18"
        ><div class="video">
          <video
            ref="video"
            class="video_player"
            :src="video_url"
            controls="controls"
            controlslist="nodownload"
          >
            您的浏览器不支持 video 标签。
          </video>

          <div class="video_desc">
            <span class="desc_label">课程简介:</span>
            <span class="desc_content">{{ video_desc }}</span>
          </div>
        </div></el-col
      >
      <el-col :span="6">
        <el-card>
          <div class="videolist">
            <div class="label">
              <span>播放列表</span>
            </div>
            <div class="videos">
              <div
                v-for="(item, index) of videolist"
                :key="index"
                @click="StartVideo(item, index)"
                v-bind:class="{ item: index !== tab, item_focus: index == tab }"
              >
                <i style="margin-left: 10px" class="el-icon-video-play"></i>
                <span style="margin-left: 10px">{{ item.title }}</span>
              </div>
            </div>

            <div></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "traininglist",
  data() {
    return {
      title: "",
      videolist: [], //视频列表
      tab: 0,
      video_url: "",
      video_desc: "",
    };
  },
  mounted() {
    this.title = this.$route.query.title;
    this.videolist = this.$route.params.videolist;
    if (this.videolist) {
      this.video_url = this.videolist[0].url;
      this.video_desc = this.videolist[0].desc;
    }
  },
  methods: {
    StartVideo(item, index) {
      console.log("播放视频");
      console.log(item);
      this.tab = index;
      this.video_url = item.url;
      this.video_desc = item.desc;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  box-sizing: border-box;
  padding: 15px;
  margin: 15px;

  .row-bg {
    margin-top: 20px;

    .video {
      .video_player {
        width: 100%;
      }
      .video_desc {
        margin-top: 15px;
        .desc_label {
          font-weight: bold;
        }
        .desc_content {
          margin-left: 10px;
        }
      }
    }
    .videolist {
      .label {
        line-height: 40px;
        font-size: 16px;
        font-weight: bold;
        border-bottom: 1px solid gainsboro;
      }
      .videos {
        padding-top: 10px;
        .item {
          cursor: pointer;
          line-height: 40px;
          font-size: 16px;
        }

        .item_focus {
          cursor: pointer;
          line-height: 40px;
          font-size: 16px;
          background: #e6f7ff;
        }
      }
    }
  }
}
</style>
